import * as yup from "yup";
import { requiredField } from "../../../../../common/infrastructure/helpers/yupHelper";
import { BULK_DELETE_CONFIRMATION_WORD } from "./bulkDeleteUserEventsFormModel";

/** The same word the permanent deletion of reservations asks for: one word for every irreversible step. */
export const MERGE_USERS_CONFIRMATION_WORD = BULK_DELETE_CONFIRMATION_WORD;

export const isMergeConfirmationWordValid = (value: string | undefined) =>
  (value ?? "").trim().toLowerCase() === MERGE_USERS_CONFIRMATION_WORD;

export const mergeUsersFormSchema = yup
  .object({
    sourceUserId: yup
      .number()
      .typeError(requiredField("Акаунт за сливане"))
      .positive(requiredField("Акаунт за сливане"))
      .required(requiredField("Акаунт за сливане")),
    confirmationWord: yup
      .string()
      .required()
      .test(
        "matches-confirmation-word",
        `Моля изпишете думата "${MERGE_USERS_CONFIRMATION_WORD}" в полето по-долу.`,
        isMergeConfirmationWordValid,
      ),
  })
  .required();

export type IMergeUsersFormModel = yup.InferType<typeof mergeUsersFormSchema>;

export const mergeUsersFormDefaultValues: IMergeUsersFormModel = {
  sourceUserId: undefined as unknown as number,
  confirmationWord: "",
};

/** What moves from the merged ("old") account; GET /User/GetMergePreview. */
export interface IUserMergePreviewCounts {
  reservations: number;
  gymVisits: number;
  cards: number;
  depositTransactions: number;
  goals: number;
  bodyMetrics: number;
  notes: number;
  forms: number;
  reviews: number;
  workouts: number;
  giftVouchers: number;
  orders: number;
  historyEntries: number;
  communications: number;
}

export interface IUserMergePreview {
  sourceUserId: number;
  /** "First Last" of the account that gets merged and deleted. */
  sourceName: string;
  counts: IUserMergePreviewCounts;
  /** Deposit money that moves with the old account (can be 0 or negative). */
  depositBalance: number;
  /** Family the old account brings over; null if none or the same family. */
  familyName: string | null;
  /** Bulgarian labels of the viewed account's empty fields that get filled, e.g. "Имейл". */
  filledFields: string[];
  /** Informational, not blocking. */
  warnings: string[];
  /** Blocking: the merge is refused while any are left. */
  conflicts: string[];
  canMerge: boolean;
}

/** The preview's counts in display order, with their Bulgarian labels. */
export const MERGE_PREVIEW_COUNT_LABELS: {
  key: keyof IUserMergePreviewCounts;
  label: string;
}[] = [
  { key: "reservations", label: "Резервации" },
  { key: "gymVisits", label: "Посещения в залата" },
  { key: "cards", label: "Карти" },
  { key: "depositTransactions", label: "Депозитни транзакции" },
  { key: "goals", label: "Цели" },
  { key: "bodyMetrics", label: "Метрики" },
  { key: "notes", label: "Бележки" },
  { key: "forms", label: "Формуляри" },
  { key: "reviews", label: "Отзиви" },
  { key: "workouts", label: "Тренировки" },
  { key: "giftVouchers", label: "Ваучери" },
  { key: "orders", label: "Поръчки" },
  { key: "historyEntries", label: "Записи в историята" },
  { key: "communications", label: "Имейли/SMS/известия" },
];
